export class CaseTypeCalcRequest {
  PrimaryProcedureCode: string;
  SecondaryProcedureCodes: string;
}
